module.exports = __webpack_public_path__ + "static/media/c172.10ad47e1.png";